import { Module } from "vuex";

/**
 * 竣工评论数据模块
 * @type {Module}
 */
export const scoring = {
         namespaced: true,
         state: {
           // 全国冷暖风水服务能力评分-满意度
           arrServicePowerEvaScoreList: [
             {
               title: "全国冷暖风水服务能力评分",
               score: 0,
               EvaScoreList: [
                 {
                   name: "空调系统施工能力",
                   value: 0,
                 },
                 {
                   name: "地暖系统施工能力",
                   value: 0,
                 },
                 {
                   name: "主机安装能力",
                   value: 0,
                 },
                 {
                   name: "交接问题",
                   value: 0,
                 },
                 {
                   name: "质量问题",
                   value: 0,
                 },
                 {
                   name: "照图施工能力",
                   value: 0,
                 },
                 {
                   name: "系统调试能力",
                   value: 0,
                 },
                 {
                   name: "系统材料使用规范",
                   value: 0,
                 },
                 {
                   name: "施工安全能力评估",
                   value: 0,
                 },
                 {
                   name: "艾暖通使用熟练度",
                   value: 0,
                 },
               ],
             },
             {
               title: "客户满意度评分",
               score: 0,
               EvaScoreList: [
                 {
                   name: "销售人员满意度",
                   value: 0,
                 },
                 {
                   name: "安装人员满意度",
                   value: 0,
                 },
                 {
                   name: "产品使用满意度",
                   value: 0,
                 },
                 {
                   name: "售后服务满意度",
                   value: 0,
                 },
                 {
                   name: "综合满意度",
                   value: 0,
                 },
               ],
             },
           ],
           // 全国冷暖风水服务能力月度评分-满意度
           arrServicePowerMothEvaScoreList: [
             {
               title: "全国冷暖风水服务综合能力月度评分",
               score: 0,
               EvaScoreList: [
                 {
                   name: "空调系统施工能力",
                   value: 0,
                 },
                 {
                   name: "地暖系统施工能力",
                   value: 0,
                 },
                 {
                   name: "主机安装能力",
                   value: 0,
                 },
                 {
                   name: "交接问题",
                   value: 0,
                 },
                 {
                   name: "质量问题",
                   value: 0,
                 },
                 {
                   name: "照图施工能力",
                   value: 0,
                 },
                 {
                   name: "系统调试能力",
                   value: 0,
                 },
                 {
                   name: "系统材料使用规范",
                   value: 0,
                 },
                 {
                   name: "施工安全能力评估",
                   value: 0,
                 },
                 {
                   name: "艾暖通使用熟练度",
                   value: 0,
                 },
               ],
             },
             {
               title: "全国冷暖风水服务综合能力月度评分",
               score: 0,
               EvaScoreList: [
                 {
                   name: "销售人员满意度",
                   value: 0,
                 },
                 {
                   name: "安装人员满意度",
                   value: 0,
                 },
                 {
                   name: "产品使用满意度",
                   value: 0,
                 },
                 {
                   name: "售后服务满意度",
                   value: 0,
                 },
                 {
                   name: "综合满意度",
                   value: 0,
                 },
               ],
             },
           ],
           // 服务商能力排名数据
           arrServiceRankingList: [
             {
               company_name: "武汉华城恒信工贸有限公司",
               contract_num: 32,
               service_score: 80,
               customer_score: 80,
               composite_score: 80,
             },
           ],
           // 高频问题
           arrQuestionRankList: [
             // {
             //   type: "",
             //   title: "风机盘管无防尘保护",
             //   value: 52,
             // },
             // {
             //   type: "",
             //   title: "风机盘管下部无双螺母或加弹簧垫圈固定",
             //   value: 23,
             // },
             // {
             //   type: "",
             //   title: "风机盘管出风口帆布软接与机器之间无压条固定",
             //   value: 8,
             // },
           ],
           // 月度评分数组
           arrMothScoreList: [
             { type: "项目服务评分", data: "1月", value: 7 },
             { type: "项目服务评分", data: "2月", value: 7.1 },
             { type: "项目服务评分", data: "3月", value: 0 },
             { type: "项目服务评分", data: "4月", value: 0 },
             { type: "项目服务评分", data: "5月", value: 0 },
             { type: "项目服务评分", data: "6月", value: 0 },

             //   { type: "满意度评分", data: "1月", value: 70 },
             //   { type: "满意度评分", data: "2月", value: 80 },
             //   { type: "满意度评分", data: "3月", value: 94 },
             //   { type: "满意度评分", data: "4月", value: 60 },
             //   { type: "满意度评分", data: "5月", value: 78 },
             //   { type: "满意度评分", data: "6月", value: 82 },

             //   { type: "综合评分", data: "1月", value: 78 },
             //   { type: "综合评分", data: "2月", value: 82 },
             //   { type: "综合评分", data: "3月", value: 90 },
             //   { type: "综合评分", data: "4月", value: 70 },
             //   { type: "综合评分", data: "5月", value: 50 },
             //   { type: "综合评分", data: "6月", value: 81 },
           ],
         },
         mutations: {},
         actions: {},
         getters: {},
       };
